import { PlantPerformanceFormStep } from '@/types/forms/formSteps/plantPerformanceFormStep';
import { ApplicationForm } from '@/types/forms/specific/applicationForm';
import { isTotalPlantPerformanceAbove300 } from '../common';

export const plantPerformanceStorageRules = async (
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    formStep: {
        model: PlantPerformanceFormStep;
        formModel: ApplicationForm;
    } & Vue,
): Promise<void> => {
    const storageOverallDischargePower =
        formStep.model.storage.storageOverallDischargePower.value;

    const hasTotalPlantPerformanceAbove300 = isTotalPlantPerformanceAbove300(
        formStep.formModel,
    );

    for (const module of formStep.model.storage.storageModules.items) {
        module.storageMemoryExpansion.disabled = hasTotalPlantPerformanceAbove300;
    }

    formStep.model.storage.storageTotalPower30.disabled =
        formStep.formModel.applicationType !== 'photovoltaicAndStorageLte30' ||
        storageOverallDischargePower === null ||
        storageOverallDischargePower <= 30;
};
